function merge(...args) {
    const newObject = {};
    const argsLength = args.length;
    for (let i = 0; i < argsLength; i++) {
        for (const key in args[i])
            newObject[key] = args[i][key];
    }
    return newObject;
}

export default merge;
